import { render, staticRenderFns } from "./returnModal.vue?vue&type=template&id=1375a972&"
import script from "./returnModal.vue?vue&type=script&lang=js&"
export * from "./returnModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports